import { Link } from "react-router-dom";

import { verifyUser } from "../../actions/auth";
import { useEffect, useState } from "react";
import "./styles.css";

class VerificationError extends Error {
  constructor(message) {
    this.message = message;
  }
}

const Verify = () => {
  const [isVerified, setIsVerified] = useState(false);
  const pathname = window.location.pathname.split("/");
  const data = {
    id: pathname[2],
    token: pathname[4]
  };

  useEffect(() => {
    const verify = async () => {
      try {
        const verification = await verifyUser(data);

        if (!verification) throw new VerificationError(verification.message);

        //This is not an error this is just for notification
        if (verification) setIsVerified(verification.message);
      } catch (error) {
        if (error instanceof VerificationError) {
          setIsVerified(error.message);
        }
      }
    };
    verify();
  });

  return (
    <section className="verification__page">
      <div className="container">
        <div className="verification__message">
          <h1>{isVerified ? isVerified : null}</h1>
          <div className="back__home__button">
            <Link to="/" className="btn btn-primary">
              Accueil
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Verify;
